import { Skeleton } from "@/app/components/shadcn/skeleton";

const ReviewSummarySkeleton = () => {
  return (
    <div className="bg-white border border-gray-200 rounded-lg p-6">
      <div className="flex items-center gap-3 mb-4">
        <Skeleton className="w-8 h-8 rounded-lg" />
        <Skeleton className="h-5 w-48" />
        <Skeleton className="w-4 h-4 rounded-full" />
      </div>
      <Skeleton className="h-4 w-full mb-2" />
      <Skeleton className="h-4 w-full mb-2" />
      <Skeleton className="h-4 w-3/4" />
    </div>
  );
};

export default ReviewSummarySkeleton;